module.exports = __webpack_public_path__ + "img/yjs.600e8d37.png";